var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 27,
    viewBox: "0 0 188 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 26.5909L10.7333 16.8501L2.51598 22.136L0 17.7504L8.72514 13.2955L0 8.84055L2.51598 4.4549L10.7333 9.74077L10.2947 0H15.3036L14.8651 9.74077L23.0824 4.4549L25.5984 8.84055L16.8732 13.2955L25.5984 17.7504L23.0824 22.136L14.8651 16.8501L15.3036 26.5909H10.2947Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8934 26.5909L51.3319 16.8501L43.1146 22.136L40.5986 17.7504L49.3238 13.2955L40.5986 8.84055L43.1146 4.4549L51.3319 9.74077L50.8934 0H55.9023L55.4637 9.74077L63.681 4.4549L66.197 8.84055L57.4719 13.2955L66.197 17.7504L63.681 22.136L55.4637 16.8501L55.9023 26.5909H50.8934Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.491 26.5909L91.9296 16.8501L83.7123 22.136L81.1963 17.7504L89.9214 13.2955L81.1963 8.84055L83.7123 4.4549L91.9296 9.74077L91.491 0H96.4999L96.0613 9.74077L104.279 4.4549L106.795 8.84055L98.0695 13.2955L106.795 17.7504L104.279 22.136L96.0613 16.8501L96.4999 26.5909H91.491Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.09 26.5909L132.528 16.8501L124.311 22.136L121.795 17.7504L130.52 13.2955L121.795 8.84055L124.311 4.4549L132.528 9.74077L132.09 0H137.099L136.66 9.74077L144.877 4.4549L147.393 8.84055L138.668 13.2955L147.393 17.7504L144.877 22.136L136.66 16.8501L137.099 26.5909H132.09Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.688 26.5909L173.127 16.8501L164.91 22.136L162.394 17.7504L171.119 13.2955L162.394 8.84055L164.91 4.4549L173.127 9.74077L172.688 0H177.697L177.259 9.74077L185.476 4.4549L187.992 8.84055L179.267 13.2955L187.992 17.7504L185.476 22.136L177.259 16.8501L177.697 26.5909H172.688Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsImage);
export default __webpack_public_path__ + "static/media/StarsImage.a81cf5af447e99b99c9d14c06ab7405e.svg";
export { ForwardRef as ReactComponent };